<template>
  <div class="image-gallery-popup" :style="popupStyle">
    <div class="image-gallery-popup-image">
      <img
        :src="closeButton"
        alt="closeButton"
        class="close-button"
        @click="closePopup"
      />
      <div v-if="props.popupImage?.thumbnailUrl">
        <img :src="props.popupImage.thumbnailUrl" alt="bestImage" />
      </div>
      <div v-else class="loading-container">
        <q-spinner color="#23e7a5" size="60px" />
      </div>
    </div>
    <div class="full-screen-button" @click="fullScreen">
      {{ $t("imageNavigation.fullScreen") }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

import closeButton from "@/assets/icons/close-popup.svg";

const props = defineProps([
  "popupImage",
  "toggleFullScreenImageActive",
  "mousePositionOnScreen",
  "handleImageSelected",
]);

const emit = defineEmits(["close"]);

// 486 is the width of the popup combined with the right sidebar
// 186 is width of popup and we are trying to align popup away from right sidebar
// 230 is the height of the popup and we are trying to align popup away from top of the screen
const popupStyle = computed(() => ({
  top: `${
    props.mousePositionOnScreen.y - 230 < 0
      ? 0
      : props.mousePositionOnScreen.y - 230
  }px`,
  left: `${
    props.mousePositionOnScreen.x + 20 > window.innerWidth - 486
      ? props.mousePositionOnScreen.x - 186
      : props.mousePositionOnScreen.x + 20
  }px`,
}));

function fullScreen() {
  props.handleImageSelected(props.popupImage, true);
  props.toggleFullScreenImageActive(true);
}

function closePopup() {
  emit("close");
}
</script>

<style scoped lang="scss">
.image-gallery-popup {
  width: 181px;
  height: 180px;
  background: linear-gradient(
    to bottom,
    rgba(52, 52, 52, 0.5),
    rgba(137, 136, 136, 0.5)
  );
  backdrop-filter: blur(15.9px);
  position: fixed;
  z-index: 1000;
  border-radius: 10px;
  border: 1px solid linear-gradient(to bottom, #343434, #898888); // Updated border to match gradient
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .image-gallery-popup-image {
    width: 100%;
    height: 100%;
    img {
      width: 160px;
      height: 120px;
      border-radius: 10px;
    }
    .close-button {
      position: absolute;
      top: -5px;
      right: -5px;
      cursor: pointer;
      width: 24px;
      height: 24px;
    }
  }

  .full-screen-button {
    width: 100%;
    height: 33px;
    background: #23e7a5;
    border-radius: 10px;
    color: #000000;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    padding: 5px 0;
    cursor: pointer;
  }

  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    height: 100%;
  }
}
</style>
